// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface DocusignConfigOut {}

export const DocusignConfigOutSerializer = {
  _fromJsonObject(_object: any): DocusignConfigOut {
    return {};
  },

  _toJsonObject(_self: DocusignConfigOut): any {
    return {};
  },
};
